import { PerspectiveCamera } from 'three';
import Sizes from '../utils/Sizes.js';

export default class Camera {
    constructor() {
        // Singleton pattern
        if (Camera.instance) {
            return Camera.instance;
        }
        Camera.instance = this;

        // Setup
        this.sizes = Sizes.getInstance();

        // Create camera
        this.cameraBackground = new PerspectiveCamera(
            60,
            this.sizes.aspectRatio,
            0.1,
            1000
        );

        this.cameraBackground.position.set(0, 2, 6);
        this.cameraBackground.lookAt(0, 2, 6);
        this.cameraBackground.updateProjectionMatrix();

        this.cameraForeground = new PerspectiveCamera(
            45,
            this.sizes.aspectRatio,
            0.1,
            1000
        );

        this.cameraForeground.position.set(0, 0, 3);
        this.cameraForeground.lookAt(0, 0, 0);
        this.cameraForeground.updateProjectionMatrix();

        // Listen to resize event
        this.sizes.on('resize', () => {
            this.cameraBackground.aspect = this.sizes.aspectRatio;
            this.cameraBackground.updateProjectionMatrix();

            this.cameraForeground.aspect = this.sizes.aspectRatio;
            this.cameraForeground.updateProjectionMatrix();
        });
    }

    // Static method to get the instance
    static getInstance() {
        if (!Camera.instance) {
            Camera.instance = new Camera();
        }
        return Camera.instance;
    }

    reset() {
        // Reset to default view
        // this.camera.position.set(0, 3, 5);
        // this.camera.lookAt(0, 1, 0);
    }
}
